// extracted by mini-css-extract-plugin
export default {"mantineDropzoneRoot":"FileUploadBox_mantineDropzoneRoot__A1CJv"};